import { AgsRecoverFreespinsState } from "ags/state-machine/states/ags-recover-freespins-state";
import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { ThemeFreespinsBlockersComponent } from "components/theme-freespins-blockers-component";
import { ThemePigComponent } from "components/theme-pig-component";
import { gameLayers } from "game-layers";
import { ThemeGridSizeResult } from "integration/results/theme-grid-size-result";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class ThemeRecoverFreespinsState extends AgsRecoverFreespinsState {
    public onEnter() {
        super.onEnter();

        gameLayers.MatrixForeground.setScene("freespins").execute();
        gameLayers.MatrixBackground.setScene("freespins").execute();
        gameLayers.SymbolAnimations.setScene("freespins").execute();
        gameLayers.Jackpots.setScene("freespins").execute();
        gameLayers.Banners.setScene("freespins").execute();
        gameLayers.Background.setScene("freespins").execute();
    }

    protected setupMatrixComponent() {
        Components.get(MatrixComponent).change("freespins", [3,3,3,3]);
    }
}
